export default __webpack_public_path__ + "static/media/reviews_white_back.d4616561.png";